import { axios, updateAWSCredentials } from "./core";
import { handleResponse, handleError } from "./response";

const getAWSCredential = () =>
  axios
    .post("/aws/s3/credentials/get", {})
    .then(handleResponse)
    .then((data) => {
      updateAWSCredentials(data);
    })
    .catch(handleError);

const awsAPI = {
  getAWSCredential,
};

export default awsAPI;
